// search.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private apiUrl = '/global_search/search/';
  private searchResults = new BehaviorSubject<any[]>([]);
  currentResults = this.searchResults.asObservable();

  constructor(private api: ApiService) { }

  search(query: string): Observable<any> {
    return this.api.getAPI(`/global_search/search/?query=${query}`);
  }
}